import { language as lan_shippingCostTable } from "./shipping-cost-table";
let language = {
    SHIPPING_COST_TITLE: "Shipping Calculator",
    SHIPPING_COUNTRY_TITLE: "Choose country or region for delivery :",
    SHIPPING_COUNTRY_ERROR: "No results match",
    SHIPPING_DELIVERY: "No results match",
    SHIPPING_RESET: "Reset",
    SHIPPING_ESTIMATED: "Estimated shipping costs :",
    SHIPPING_TABLE_EXPORT:"export",
    SHIPPING_content_1: "Please verify that the product on the table matches your selection to avoid any potential misunderstandings.",
    SHIPPING_content_2: "Delivery times are estimates and may vary depending on the volume of orders bein processed. he exact costs and delivery times wil be displayed at Checkout for your review.",
    ...lan_shippingCostTable
    
}

export { language }